import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconLamudi from '../build/icon-lamudi'

export const IconLamudi: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconLamudi} />
}

export default IconLamudi
